import { UserProfileType, UserRole } from '@shared/generated/graphql';
import { UserFeatures } from 'clerk_common';

export type User = {
  id: string;
  userName?: string;
  name?: string;
  email?: string;
  roles: UserRole[];
  excludeFromReporting?: boolean;
  features?: UserFeatures;
  lastSignedIn?: Date;
  profile?: HumanProfile;
  userProfile?: UserProfile;
};

export type BasicUser = {
  id: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  roles: UserRole[];
  excludeFromReporting?: boolean;
  profile?: UserProfile;
};

export type PhoneNumber = {
  phoneNumber?: string;
  extension?: string;
};

export type UserProfile = HumanProfile | AIProfile;

export type HumanProfile = {
  type: UserProfileType.HUMAN;
  phoneNumber?: PhoneNumber;
  dtmfPin?: string;
  name?: string;
};

export type AIProfile = {
  type: UserProfileType.AI;
  name?: string;
};

type GetNameArgs = {
  firstName?: string | null;
  lastName?: string | null;
};
export function toName(user: GetNameArgs) {
  const els = [user.firstName, user.lastName].filter((el) => el);
  return els.join(' ');
}
